<!-- Overlay (backdrop) -->
<div
  ngpDialogOverlay
  class="sui-dialog-overlay"
  [style]="overlayStyles"
  [ngpDialogOverlayCloseOnClick]="dialogRef.config.closeOnClick"
></div>

<!-- Dialog root (main panel). Also a boundary: header/footer triggers sit
     outside the content panes, so they resolve here instead of body. -->
<div
  ngpDialog
  class="sui-dialog-tabs"
  [class]="sizeClass"
  [style]="customStyles"
  [ngpDialogRole]="dialogRef.config.role"
  [ngpDialogModal]="dialogRef.config.modal"
  data-sui-popover-boundary
>
  <!-- Panes row: sidebar + content. The footer sits below both (WAP-1632). -->
  <div class="sui-dialog-tabs__body">
    <!-- LEFT PANEL -->
    <aside class="sui-dialog-tabs__left">
      <header class="sui-dialog-tabs__left-header">
        <ng-container *ngTemplateOutlet="leftHeaderTpl"></ng-container>
      </header>

      <div class="sui-dialog-tabs__left-content" data-sui-popover-boundary>
        <ng-container *ngTemplateOutlet="leftContentTpl"></ng-container>
      </div>
    </aside>

    <!-- RIGHT PANEL -->
    <section class="sui-dialog-tabs__right">
      <header class="sui-dialog-tabs__right-header">
        <ng-container *ngTemplateOutlet="rightHeaderTpl"></ng-container>
      </header>

      <main class="sui-dialog-tabs__right-content" data-sui-popover-boundary>
        <ng-container *ngTemplateOutlet="rightContentTpl"></ng-container>
      </main>
    </section>
  </div>

  <footer class="sui-dialog-tabs__footer">
    <ng-container *ngTemplateOutlet="rightFooterTpl"></ng-container>
  </footer>
</div>
